<template>
  <div class="main">
    <div class="nav">
      <van-nav-bar
          title="核酸检测"
          left-arrow
          left-text="返回"
          @click-left="onClickLeft"
        />
      <div class="top"></div>
    </div>
  <div>
        <div class="test_title" >
      <div class="title_info">
        <div class="title_name">姓名：{{name}}</div>
        <div class="title_cardno">卡号：{{PatientID}}</div>
      </div>
      <div class="title_icon" @click.stop="show=true">
        <van-icon name="exchange" size="7vw" color="#5B8DF6" />
        <div>切换</div>
      </div>
    </div>
    <van-popup v-model="show" round  position="top" :style="{ height: '30%' }" >
        <div class="pop_cell"  v-for="(item,index) in cardList" :key="index" @click="changeinfo(item)">
            <div class="pop_name">{{item.PatientName}}</div>
            <div class="pop_card">{{item.PatientID}}</div>
        </div>
    </van-popup>
    <div class="Tips">
      <p>
        <div>温馨提示：</div>
        <div v-for="(item,index) in tips" :key="index">{{item.value}}</div>
        
      </p>
    </div>
   
  </div>
    <div class="foot">
        <div class="a_btn">
            <van-button type="info" block @click="godetail()">确认检测</van-button>
        </div>
        <div class="b_btn">
            <van-button plain type="info" block @click="onClickLeft">取消</van-button>
        </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav";
import backindex from "@/mixins/backindex";
import setOptions from "@/mixins/setOption";
export default {
    mixins: [setOptions, backindex],
  components: {
    Nav,
  },
  data() {
    return {
      show: false,
      showName: "",
      fee: "",
      reportAddress: "",
      feeType: "",
      medCardNo: "",
      name: "",
      cardList: [],
      tips: [],
      path: "",
      PatientID: "",
    };
  },
  methods: {
    async godetail() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/registerService/DoNAT";
        let data = {
          PatientID: this.PatientID,
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            this.$hideLoad();
            console.log(data);
            if (data.data.data.ResultCode == "0") {
              this.$router.push({
                path: "/pay_list_D",
                query: {
                  clientId: this.PatientID,
                  name:this.name
                },
              });
            }
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.isLoad = true;
      }
    },
    onClickLeft() {
      this.$router.push("/index");
    },
    changeinfo(item) {
      this.PatientID = item.PatientID;
      this.name = item.PatientName;
      this.show = false;
    },

    async getinfo() {
      //请求医院信息
      // 医院的名字、地址、banner图片、图标、功能
      try {
        this.$showLoad();
        let url = "/register/getAcidSeeting";
        let data = null;
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "post",
          null,
          (data) => {
            console.log(data.data);
            this.reportAddress = data.data.reportAddress;
            this.tips = data.data.tips;
            this.feeType = data.data.feeType;
            this.showName = data.data.showName;
            this.fee = data.data.fee;
            this.$hideLoad();
          }
        );
      } catch (error) {
        this.isLoad = false;
        this.$hideLoad();
        this.$toast.fail("网络连接失败");
      }
    },
    async getmedicalcard() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/medicalcard/getclientcardlist";
        let data = null;
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            console.log(data);
            this.cardList = [...data.data];
            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.isLoad = true;
      }
    },
    //go选择用户
    goconfUser() {
      this.$router.push("/patient_card_selectuser");
    },
  },
  beforeRouteEnter(to, from, next) {
    // console.log(from.path);

    next((vm) => {
      // this.path= from.path
      vm.path = from.path;
      // console.log(vm.path);
    });
  },
  mounted() {
    //
    if (this.$route.query) {
      this.PatientID = this.$route.query.clientId;
      this.name = this.$route.query.name;
    }
    if (!this.PatientID || this.PatientID == "") {
      // this.Dialog();
      this.goconfUser();
      return;
    }
    this.getinfo();
    this.getmedicalcard();
  },
};
</script>

<style  lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  background-color: #f7f7f7;
  .pop_cell {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    line-height: 6vh;
    width: 95%;
    margin: 0px auto;
  }
  .nav {
    height: 6vh;
    width: 100%;
    .top {
      height: 12vh;
      width: 100%;
      background-color: #5b8df6;
    }
  }
  .test_title {
    display: flex;
    flex-direction: row;
    height: 15vh;
    width: 93%;
    margin: 0px auto;
    font-size: 16px;
    margin-top: 3vh;
    border: 1px solid white;
    background-color: white;
    border-radius: 6px;
    .title_info {
      width: 60vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .title_icon {
      width: 40vw;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
  }
  .Tips {
    width: 93%;
    margin: 0px auto;
    height: 60vh;
    font-size: 16px;
    margin-top: 2vh;
    margin-bottom: 4vh;
    background-color: white;
    border: 1px solid white;
    padding: 5px;
    line-height: 4vh;
    border-radius: 6px;
    .red {
      color: #c44569;
    }
  }

  .foot {
    width: 90%;
    margin: 0px auto;
    height: 7vh;
    display: flex;
    flex-direction: row;
    .a_btn {
      width: 50%;
      margin-right: 8vw;
    }
    .b_btn {
      width: 50%;
    }
  }
}
</style>